import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import ButtonViewModel from '@/ViewModels/Controls/ButtonViewModel';
import ImageViewModel from '@/ViewModels/Controls/ImageViewModel';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import Button from '@/Controls/Button';

export default class ButtonFactory extends ControlFactory {

    /** 
     *  @override
     */
    control: Button;
    private jQueryControl: JQuery;
    private ButtonViewModel = ComponentManager.getViewModel<typeof ButtonViewModel>('ButtonViewModel');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');
    protected ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModel>('ImageViewModel');
    private Button = ComponentManager.getControl<typeof Button>('Button');

    /**
     * @override
     */
    public viewModel: ButtonViewModel;

    public constructor(params: any) {
        super(params);
        this.labelPosition = 'None';
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = this.detailViewItem.viewModel || new this.ButtonViewModel({
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isFocusable: this.isFocusable,
            parentLocator: this.locator,
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            }),
            locator: this.detailViewItem.name,
            label: new this.LabelViewModel({
                parentLocator: this.locator,
                locator: this.detailViewItem.name + '.label',
                ergName: this.detailViewItem.ergName
            }),
            onClick: () => {
                this.context.genericObject.getObservable(this.detailViewItem.name)('click_' + new Date().getTime());
            },
            image: this.createImageViewModel()
        })
        
        this.control = new this.Button(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        return this.jQueryControl;
    }

    private createImageViewModel(): ImageViewModel {
        if (this.detailViewItem.iconUrl) {
            return new this.ImageViewModel({
                parentLocator: this.locator,
                locator: this.detailViewItem.name + '.image',
                source: this.detailViewItem.iconUrl,
                alternativeText: new LabelViewModel({
                    ergName: this.detailViewItem.tooltip
                })
            });
        }
        else {
            return null;
        }
    }
}

ComponentManager.setFactory('Button', ButtonFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');